import React from 'react';

const renderField = ({ input, label,length,valueForm,className, type,placeholder,meta: { touched, error } }) => (

  
  <div className="form-group">
  {label ? <label className="control-label">{label}</label> : ""} 
  
      <input 
          type={type} 
          {...input} 
          className={className?className:"form-control"} 
          value={input.value}
        //  value={input.value?input.value:valueForm}
          placeholder={placeholder}  
          maxLength={length}/>
      {touched && error && <span className="text-danger">{error}</span>}
  
  </div>
);

export default renderField;



// WEBPACK FOOTER //
// ./src/container/renderField.js